// extracted by mini-css-extract-plugin
module.exports = {"button":"index_button__2Xslv","disabled":"index_disabled__34fH8","small":"index_small__2E0Pc","basic":"index_basic__75-Ls"};